import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer_wrap footer_custom footer_custom_16742 footer_custom_footer-default-printo">
      <div className="elementor elementor-16742">
        {/* Spacer Section */}
        <section className="elementor-section elementor-top-section elementor-element elementor-element-070611a elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
          <div className="elementor-container elementor-column-gap-extended">
            <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-48d5984 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="sc_layouts_item elementor-element elementor-element-e842674 sc_height_large sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Footer Content */}
        <section className="elementor-section elementor-top-section elementor-element elementor-element-77ee0ac sc_layouts_row sc_layouts_row_type_compact scheme_dark elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
          <div className="elementor-container elementor-column-gap-extended">
            {/* Hello Column */}
            <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-43296ff sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-wrap elementor-element-populated">
                {/* Logo Card */}
                <div style={{
                  background: '#ffffff',
                  padding: '0px 20px',
                  borderRadius: '15px',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  marginBottom: '20px'
                }}>
                  <div style={{ marginRight: '0px' }} className="sc_layouts_item elementor-element elementor-element-cd0074c sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_logo trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                    data-id="cd0074c" data-element_type="widget"
                    data-widget_type="trx_sc_layouts_logo.default">
                    <div className="elementor-widget-container">
                      <a href="/#"
                        className="sc_layouts_logo sc_layouts_logo_default trx_addons_inline_1884545146"
                        style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <img
                          loading="lazy"
                          src="/favicon-modli.png"
                          alt="Modli 3D Icon"
                          width="30"
                          height="30"
                          style={{ display: 'block', height: '1.8em' }} />
                        <span style={{
                          fontSize: '18px',
                          fontWeight: '800',
                          color: '#1c212a',
                          letterSpacing: '0.5px',
                          fontFamily: "'Red Hat Display', sans-serif"
                        }}>MODLI 3D</span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="sc_layouts_item elementor-element elementor-element-5feba50 sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container" style={{ color: '#ffffff', fontWeight: '400', opacity: 0.7, fontSize: '15px' }}>
                    Where imagination takes shape
                  </div>
                </div>
              </div>
            </div>

            {/* Office Column */}
            <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-e572e95 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="sc_layouts_item elementor-element elementor-element-fa6be28 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="sc_title sc_title_default">
                      <h6 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                        <span className="sc_item_title_text">Office</span>
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-4d145aa sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-470167e sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <p>Jothi Towers,<br />Plot No 32/33,<br />Krishna Avenue First Street,<br />
                      Sri Krishna Avenue, Rajakilpakkam, <br />Chennai - 600073. <br />(Behind Hansa Garden)</p>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-f84219e sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-7fd1e18 sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <p>
                      <a className="underline_anim underline_do_hover" href="mailto:info@email.com">info@modli3d.com</a>
                    </p>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-e2ed0ac sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-d0f5ce9 sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <span className="trx_addons_alter_text">
                      <a href="tel:+18408412569">+91 9150027017</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Links Column */}
            <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-4f4fe4f sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="sc_layouts_item elementor-element elementor-element-8ed7e02 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="sc_title sc_title_default">
                      <h6 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                        <span className="sc_item_title_text">Links</span>
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-2955a9d sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-103ce96 sc_fly_static elementor-widget elementor-widget-trx_widget_custom_links trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="widget_area sc_widget_custom_links">
                      <aside className="widget widget_custom_links">
                        <ul className="custom_links_list" style={{ paddingLeft: 0 }}>
                          <li className="custom_links_list_item">
                            <Link className="custom_links_list_item_link" to="/">
                              <span className="custom_links_list_item_title">Home</span>
                            </Link>
                          </li>
                          {/* <li className="custom_links_list_item">
                            <Link className="custom_links_list_item_link" to="/our-services">
                              <span className="custom_links_list_item_title">Services</span>
                            </Link>
                          </li> */}
                          <li className="custom_links_list_item">
                            <Link className="custom_links_list_item_link" to="/about-us">
                              <span className="custom_links_list_item_title">About Us</span>
                            </Link>
                          </li>
                          {/* <li className="custom_links_list_item">
                            <Link className="custom_links_list_item_link" to="/portfolio-list">
                              <span className="custom_links_list_item_title">Portfolio</span>
                            </Link>
                          </li> */}
                          <li className="custom_links_list_item">
                            <Link className="custom_links_list_item_link" to="/contact">
                              <span className="custom_links_list_item_title">Contact Us</span>
                            </Link>
                          </li>
                        </ul>
                      </aside>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Get in Touch Column */}
            <div className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-38d33c0 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="sc_layouts_item elementor-element elementor-element-74b130b sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="sc_title sc_title_default">
                      <h6 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                        <span className="sc_item_title_text">Get in Touch</span>
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-223cf8d sc_fly static elementor-widget elementor-widget-trx_sc_socials trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="sc_socials sc_socials_icons_names sc_align_none">
                      <div className="socials_wrap sc_item_content">
                        <a target="_blank" rel="noopener noreferrer nofollow" href="https://www.facebook.com/share/1F4rX7FHd9/" className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons_names">
                          <span className="social_icon social_icon_facebook-1">
                            <span className="icon-facebook-1"></span>
                          </span>
                          <span className="social_name social_facebook-1">Facebook</span>
                        </a>
                        <a target="_blank" rel="noopener noreferrer nofollow"  href="https://www.instagram.com/modli3d?igsh=YnFpbWJrNHY1ZzVu" className="social_item social_item_style_icons sc_icon type icons social_item_type_icons_names">
                          <span className="social_icon social_icon_instagram">
                            <span className="icon-instagram"></span>
                          </span>
                          <span className="social_name social_instagram">Instagram</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Copyright Section */}
        <section className="elementor-section elementor-top-section elementor-element elementor-element-5be5f27 sc_layouts_row sc_layouts_row_type_compact scheme_dark elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
          <div className="elementor-container elementor-column-gap-extended">
            <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-cabb883 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks inited">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="sc_layouts_item elementor-element elementor-element-4f0f6fb sc_height_small sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-bbf3e47 sc_layouts_hide_on_wide sc_layouts_hide_on_desktop sc_layouts_hide_on_notebook sc_layouts_hide_on_tablet sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts item elementor-element elementor-element-47d8356 elementor-widget-divider--view-line sc_fly_static elementor-widget elementor-widget-divider trx_addons_parallax layers inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-divider">
                      <span className="elementor-divider-separator"></span>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-1fef2bc sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-191b388 sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks inited">
                  <div className="elementor-widget-container" style={{ textAlign: 'center' }}>
                    Modli 3D Private Limited © 2026. All Rights Reserved.
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-d2ad77a sc_fly static elementor-widget elementor-widget-spacer trx_addons_parallax_layers inited trx_addons_parallax_blocks inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="sc_layouts_item elementor-element elementor-element-ae6058c sc_layouts_hide_on_mobile sc_fly static elementor-widget elementor-widget-spacer trx_addons_parallax_layers inited trx_addons_parallax_blocks inited">
                  <div className="elementor-widget-container">
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
